import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Button from "Components/Button";
import CustomSelect from "Components/CustomSelect";
import RadioButton from "Components/RadioButton";
import { FileUploader } from "react-drag-drop-files";
import DragandDrop from "../../Assets/Svg/Auth/DragandDrop.svg";
import SuccessCard from "Components/SuccessCard";
import { useNavigate } from "react-router-dom";
import { Modal, Toast } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  addUserFeedback,
  getAssessmentAnswer_USER,
  getIndividualAnswer,
  getIndividualInsight,
  getUserFeedbackModule,
  multiUpload,
  saveIndividualAnswer,
  saveIndividualInsight,
  userFeedbackModule,
  userFinalSubmit,
} from "../../Redux/Slices/User/userSlice";
import "./styles.scss";
import { MdDeleteOutline } from "react-icons/md";
import Loader from "Components/Loader";
import { motion, AnimatePresence } from "framer-motion";
import MatrixQuestions from "Components/Matrix";
import DraggableItem from "Components/Rearrange";
import RearrangementQuestion from "Components/RearrangementQuestion";
import { setMatrixAnswer, } from "../../Redux/Slices/User/matrixAnswers";
import ReactQuill from "react-quill-new";
import { useForm, useFormContext } from "react-hook-form";
import GreaseType from "Components/GreaseType";
import Checkbox from "Components/Checkbox";
import { setGreaseAnswer } from "../../Redux/Slices/User/greaseAnswers";
import scrollToTop from "Services/Utils/scrolltoTop";
import { updateRearrangeOrder } from "../../Redux/Slices/User/rearrange";
import { compressImage } from "Services/Utils/imageCompression";

const slideVariants = {
  enter: (direction) => ({
    x: direction > 0 ? "100%" : "-100%",
    opacity: 0,
    position: "absolute",
    width: "100%",
  }),
  center: {
    x: 0,
    opacity: 1,
    position: "relative",
    width: "100%",
  },
  exit: (direction) => ({
    x: direction < 0 ? "100%" : "-100%",
    opacity: 0,
    position: "absolute",
    width: "100%",
  }),
};

const QuestionaryComponent = ({
  categories,
  backlog_id,
  categoryIndex,
  selectedCategoryId,
  setSelectedCategoryId,
  currentSubCategory,
  subCategoryIndex,
  setSubCategoryIndex,
  formMethods,
  companyName,
  assessmentId,
  setCategoryIndex,
  successOpen,
  setSuccessOpen,
  isCompleted,
  isSubModuleClicked,
  onAfterSkipSave,
  openSubmitModal,
  setOpenSubmitModal,
}) => {
  // const [successOpen, setSuccessOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [showMoveToButton, setShowMoveToButton] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(1); // default to 1
  const [hoveredRating, setHoveredRating] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [direction, setDirection] = useState(0);
  const questionsRef = useRef(null);
  const [matrixAnswers, setMatrixAnswers] = useState({});
  const [savedAnswersFromAPI, setSavedAnswersFromAPI] = useState([]);
  const [savedGreaseAnswers, setSavedGreaseAnswers] = useState([])
  const [showSubmitBtn, setShowSubmitBtn] = useState(false)
  const [feedbackForModule, setFeedbackForModule] = useState({});
  const [ratingForModule, setRatingForModule] = useState({});
  const [hoveredRatingForModule, setHoveredRatingForModule] = useState(null);
  const [history, setHistory] = useState([]);
  const [sendErrorToChild, setSendErrorToChild] = useState(false)
  const [isLoader, setIsLoader] = useState(false);
  const allRearrangeAnswers = useSelector(state => state.rearrange.answersByQuestion);


  const isLoading = useSelector((state) => state.user.isLoading);
  const getMatrixAnswers = useSelector((state) => state.matrixAnswers.matrix)
  const getGreaseAnswers = useSelector((state) => state.greaseAnswers.greaseAnswers)
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const { watch } = useForm();

  const roleMap = {
    1: "Admin",
    2: "Assessor",
    3: "User",
    4: "Approver"
  };

  useEffect(() => {
    const updatedData = [...categories]
    if (isSubModuleClicked) {
      setHistory(prevHistory => [...prevHistory, updatedData[categoryIndex].sub_categories[subCategoryIndex].subCategory_id])
    }
  }, [isSubModuleClicked, subCategoryIndex]);

  useEffect(() => {
  if (openSubmitModal) {
    setShow(true);              // open modal
    setOpenSubmitModal(false);  // reset parent state
  }
}, [openSubmitModal]);



  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const roleName = roleMap[userDetails?.role];
  const {
    setValue,
    formState: { errors },
    setError,
    clearErrors,
    reset,
    getValues,
  } = formMethods;

  useEffect(() => {
    clearErrors();
  }, [setValue, categories, categoryIndex, subCategoryIndex]);

  useEffect(() => {
    if (
      categories.length === 0 ||
      categoryIndex === undefined ||
      subCategoryIndex === undefined
    ) {
      return;
    }

    const currentCategory = categories[categoryIndex];
    const currentSubCategory = currentCategory?.sub_categories[subCategoryIndex];

    if (!currentSubCategory) return;

    if (!currentSubCategory?.questions?.length && !currentSubCategory?.isFeedback) {
      dispatch(
        getIndividualInsight({
          assessment_id: assessmentId,
          category_id: currentCategory?.category_id,
          callBack: getSavedInsightsData,
        })
      );
    }
    else if (currentSubCategory?.isFeedback) {
      dispatch(
        getUserFeedbackModule({
          assessment_id: assessmentId,
          category_id: categories[categoryIndex]?.category_id,
          role: roleName.toLowerCase(),
          callBack: (data) => handleGetFeedback(data, categories[categoryIndex]?.category_id),
        })
      );

    }
    else {
      const currentQuestionIds = currentSubCategory?.questions?.map(
        (question) => question?.question_id
      );

      dispatch(
        getIndividualAnswer({
          assessment_id: assessmentId,
          category_id: currentCategory?.category_id,
          sub_category_id: currentSubCategory?.subCategory_id,
          question_id: currentQuestionIds,
          callBack: getSavedAnswerData,
        })
      );
    }
  }, [categories?.length, categoryIndex, subCategoryIndex]);

  // useEffect(() => {
  //   if (!savedAnswersFromAPI || !savedAnswersFromAPI.length) return;

  //   savedAnswersFromAPI.forEach(ans => {
  //     dispatch(setMatrixAnswer({
  //       questionId: ans.question_id,
  //       subOptionId: ans.sub_option_id,
  //       optionId: ans.option_id === null ? null : ans.option_id,
  //     }));
  //   });
  //   console.log(getMatrixAnswers, "getMatrix")
  // }, [savedAnswersFromAPI, dispatch]);

  // Sync API answers to local matrixAnswers
  useEffect(() => {
    if (!savedAnswersFromAPI?.length) return;

    const grouped = savedAnswersFromAPI.reduce((acc, ans) => {
      if (!acc[ans.question_id]) acc[ans.question_id] = [];
      acc[ans.question_id].push({
        questionId: ans.question_id,
        subOptionId: ans.sub_option_id,
        optionId: ans.option_id,
      });
      return acc;
    }, {});
    setMatrixAnswers(grouped);
  }, [savedAnswersFromAPI]);


  const getSavedAnswerData = (savedAnswers) => {
    console.log(savedAnswers, "savef")
    const updatedData = [...categories];
    if (savedAnswers.length === 0) {
      const greaseQuestion = updatedData[categoryIndex]
        ?.sub_categories?.[subCategoryIndex]
        ?.questions?.find(q => q.field_type === "grease");

      if (greaseQuestion) {
        setSavedGreaseAnswers([]);
      }

      setValue("categories", updatedData);
      return;
    }


    savedAnswers.forEach((answer) => {
      const { category_id, sub_category_id, question_id, sub_option_id, option_id, bearing_size } = answer;

      const category = updatedData.find(cat => cat.category_id === category_id);
      if (!category) return;

      const subCategory = category.sub_categories.find(subCat => subCat.subCategory_id === sub_category_id);
      if (!subCategory) return;

      const question = subCategory.questions.find(q => q.question_id === question_id);
      if (!question) return;

      if (question?.is_bearing_size) {
        if (!question.bearingSizeAnswers) {
          question.bearingSizeAnswers = {
            small: null,
            medium: null,
            large: null
          };
        }

        if (bearing_size && option_id) {
          getSelectedOption(question, bearing_size, option_id);
        }
      }


      if (question.field_type === "check_box") {
        question.options.forEach(opt => {
          opt.isChecked = opt.option_id === answer.option_id;
        });
      }
      else if (question.field_type === "multi_check_box") {

        question.options.forEach(opt => {
          opt.isChecked = savedAnswers.some(ans => ans.option_id === opt.option_id && ans.question_id === question_id);
        });
      }
      else if (question.field_type === "text_box") {
        question.textAnswer = answer.text_answer || "";
      } else if (question.field_type === "matrix") {
        setSavedAnswersFromAPI(savedAnswers)
      } else if (question.field_type === "rearrange") {
        const rearrangeAnswers = savedAnswers.filter(ans => ans.question_id === question_id);

        const hasNullOptionId = rearrangeAnswers.some(ans => ans.option_id === null);

        let newOrder;
        if (hasNullOptionId) {
          newOrder = question.options;
        } else {
          newOrder = rearrangeAnswers.sort((a, b) => a.rank_id - b.rank_id);
        }

        dispatch(
          updateRearrangeOrder({
            questionId: question_id,
            newOrder: newOrder,
          })
        );
      } else if (question.field_type === "grease") {
        const greaseAnswers = savedAnswers.filter(a => a.question_id === question.question_id);
        setSavedGreaseAnswers(greaseAnswers);
      }

    });

    setValue("categories", updatedData);
  };

  const getSavedInsightsData = (data) => {

    const updatedData = [...categories];

    updatedData[categoryIndex].sub_categories[subCategoryIndex].comments =
      data?.comments || "";

    updatedData[categoryIndex].sub_categories[subCategoryIndex].mediaFiles =
      data?.media_files?.map((fileUrl) => ({
        url: fileUrl,
        name: fileUrl.split('---').pop(),
        decodedFileName: decodeURIComponent(fileUrl.split('---').pop())
      })) || [];

    const hasMediaFiles =
      updatedData[categoryIndex].sub_categories[subCategoryIndex]?.mediaFiles
        .length > 0;
    const hasComments =
      updatedData[categoryIndex].sub_categories[subCategoryIndex]?.comments.trim() !== "";

    if (hasMediaFiles || hasComments) {
      updatedData[categoryIndex].sub_categories[subCategoryIndex].isCompleted = true;
    }

    setValue("categories", updatedData);
  };

  const handleGetFeedback = (data, categoryId, subCategoryId) => {
    const updatedData = [...categories];
    if (data?.feedback) {
      const { comment, rating } = data.feedback;

      setFeedbackForModule(prev => ({
        ...prev,
        [categoryId]: comment || "",
      }));

      setRatingForModule(prev => ({
        ...prev,
        [categoryId]: rating || 0,
      }));

      if ((comment && comment.length > 0) || (rating)) {
        updatedData[categoryIndex].sub_categories[subCategoryIndex].isCompleted = true;
      }
    }
  };






  const nextCategoryName = categories?.find((item) => {
    return item?.category_id === selectedCategoryId + 1;
  });

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    const lowerStr = str.toLowerCase()
    return lowerStr
  };

  const bearingSizeOptions =
  {
    Small: "(<55mm)",
    Medium: "(55mm - 200mm)",
    Large: "(>200mm)",
  };
  const outlineButton = {
    width: "auto",
    height: "44px",
    backgroundColor: "white",
    border: "1.5px solid #1F2155",
    textAlign: "center",
    marginRight: "15px",
    marginTop: "10px",
  };
  const outlineTitle = {
    color: "#1F2155",
    fontSize: "20px",
    fontWeight: "600",
  };
  const moveToButtonTitle = {
    fontSize: "20px",
    fontWeight: "600",
  };

  const moveToButton = {
    width: "auto",
    height: "44px",
    backgroundColor: "#1F2155",
    border: "1.5px solid #1F2155",
    textAlign: "center",
    marginTop: "10px",
  };

  const savedMoveToButton = {
    width: "auto",
    height: "44px",
    backgroundColor: "#1F2155",
    border: "1.5px solid #1F2155",
    textAlign: "center",
  };
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [subCategoryIndex]);


  const handleChange = (
    parentIndex,
    subCategoryIndex,
    questionIndex,
    optionIndex,
    name,
    bearingSize = null
  ) => {
    const updatedData = [...categories];
    const currentQuestion = updatedData[parentIndex].sub_categories[subCategoryIndex].questions[questionIndex];

    if (currentQuestion.is_bearing_size) {
      // Initialize bearingSizeAnswers if it doesn't exist
      if (!currentQuestion.bearingSizeAnswers) {
        currentQuestion.bearingSizeAnswers = {
          small: null,
          medium: null,
          large: null
        };
      }

      // Update the answer for the specific bearing size
      if (bearingSize) {
        currentQuestion.bearingSizeAnswers[bearingSize] = optionIndex;
      }
    } else {
      // Handle non-bearing size questions as before
      currentQuestion.options.forEach((option) => {
        option.isChecked = false;
      });
      currentQuestion.options[optionIndex].isChecked = true;
    }


    setValue("categories", updatedData);
  };

  const handleMultiCheckChange = (
    parentIndex,
    subCategoryIndex,
    questionIndex,
    optionIndex) => {
    const updatedData = [...categories];
    const currentQuestion = updatedData[parentIndex].sub_categories[subCategoryIndex].questions[questionIndex];

    currentQuestion.options[optionIndex].isChecked =
      !currentQuestion.options[optionIndex].isChecked;


    setValue("categories", updatedData);
  }


  const getSelectedOption = (question, bearingSize, optionIndex) => {
    if (!question.bearingSizeAnswers) return false;
    return question.bearingSizeAnswers[bearingSize] === optionIndex;
  };

  // Modify the submit handling to include bearing size answers
  const prepareQuestionData = () => {
    const questionData = [];
    categories?.forEach((category) => {
      category?.sub_categories?.forEach((subCategory) => {
        subCategory?.questions?.forEach((question) => {
          if (question.is_bearing_size && question.bearingSizeAnswers) {
            // Add entries for each bearing size
            Object.entries(question.bearingSizeAnswers).forEach(([size, optionIndex]) => {
              if (optionIndex !== null) {
                questionData.push({
                  sub_category_id: subCategory.subCategory_id,
                  question_id: question.question_id,
                  option_id: question.options[optionIndex].option_id,
                  points: question.options[optionIndex].points,
                  notes: question.notes,
                  bearing_size: size
                });
              }
            });
          } else {
            // Handle non-bearing size questions as before
            const filteredOptions = question.options?.filter(
              (data) => data?.isChecked
            );
            filteredOptions?.forEach((option) => {
              questionData.push({
                sub_category_id: subCategory.subCategory_id,
                question_id: question.question_id,
                option_id: option.option_id,
                points: option.points,
                notes: question.notes,
                bearing_size: ""
              });
            });
          }
        });
      });
    });
    return questionData;
  };

  const handleNotes = (
    parentIndex,
    subCategoryIndex,
    questionIndex,
    name,
    e
  ) => {
    const updatedData = [...categories];
    updatedData[parentIndex].sub_categories[subCategoryIndex].questions[
      questionIndex
    ][name] = e?.target?.value;
    setValue("categories", updatedData);
  };

  const handleTextAnswer = (
    parentIndex,
    subCategoryIndex,
    questionIndex,
    name,
    e
  ) => {
    const updatedData = [...categories];
    updatedData[parentIndex].sub_categories[subCategoryIndex].questions[
      questionIndex
    ][name] = e?.target?.value;
    setValue("categories", updatedData);
  };

  const handleFileChange = async (files, categoryIndex, subCategoryIndex) => {
    const formData = new FormData();
    let isValid = true;
    const compressedFiles = [];

    for (const file of Array.from(files)) {
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx
      ];

      if (!allowedTypes.includes(file.type)) {
        setError("mediaFiles", {
          type: "manual",
          message: `Invalid file type: ${file.name}. Only .pdf, .png, .jpg, .jpeg, .docx, .xlsx files are allowed.`,
        });
        isValid = false;
        break;
      }

      let finalFile = file;

      if (file.type.startsWith("image/") && file.size > 1024 * 1024 && file.size < 5 * 1024 * 1024) {
        try {
          const compressedBlob = await compressImage(file, 1);
          finalFile = new File([compressedBlob], file.name, {
            type: compressedBlob.type,
            lastModified: Date.now(),
          });
        } catch (err) {
          console.log(err, "err");
          isValid = false;
          break;
        }
      }

      if (file.size > 5 * 1024 * 1024) {
        setError("mediaFiles", {
          type: "manual",
          message: "File size must not exceed 5MB.",
        });
        isValid = false;
        break;
      }

      compressedFiles.push(finalFile);
    }

    if (!isValid) return;

    clearErrors("mediaFiles");
    compressedFiles.forEach(file => {
      formData.append("files", file);
    });

    const onUploadSuccess = (uploadedFiles) => {
      const updatedData = [...categories];
      const currentFiles =
        updatedData[categoryIndex].sub_categories[subCategoryIndex].mediaFiles || [];

      const newFiles = uploadedFiles.map((file) => ({
        name: file.originalName,
        url: file.url,
      }));

      updatedData[categoryIndex].sub_categories[subCategoryIndex].mediaFiles = [
        ...currentFiles,
        ...newFiles,
      ];

      setValue("categories", updatedData);
    };

    dispatch(
      multiUpload({
        files: formData,
        callBack: onUploadSuccess,
      })
    );
  };


  const handleRemoveFile = (fileUrl, categoryIndex, subCategoryIndex) => {
    const updatedData = [...categories];
    const currentFiles =
      updatedData[categoryIndex].sub_categories[subCategoryIndex].mediaFiles ||
      [];

    updatedData[categoryIndex].sub_categories[subCategoryIndex].mediaFiles =
      currentFiles.filter((file) => file.url !== fileUrl);

    setValue("categories", updatedData);
  };

  const handleComments = (categoryIndex, subCategoryIndex, e) => {
    const updatedData = [...categories];
    updatedData[categoryIndex].sub_categories[subCategoryIndex].comments =
      e?.target?.value;
    setValue("categories", updatedData);
  };

  const sendIndividualAnswers = (question, updatedData, catIndex, subCatIndex, nextSubCategoryId) => {
    if (!updatedData[catIndex] || !updatedData[catIndex].sub_categories[subCatIndex]) {
      return Promise.resolve();
    }

    const subCategory = updatedData[catIndex].sub_categories[subCatIndex];

    let answersData = [];

    if (question.is_bearing_size) {
      answersData = ['small', 'medium', 'large']
        .filter(size => question.bearingSizeAnswers?.[size] !== null && question.bearingSizeAnswers?.[size] !== undefined)
        .map(size => {
          const optionIndex = question.bearingSizeAnswers[size];
          const selectedOption = question.options[optionIndex];
          return {
            sub_category_id: subCategory?.subCategory_id || null,
            sub_option_id: null,
            bearing_size: size,
            option_id: selectedOption?.option_id || null,
            rank_id: question.rank_id || null,
            points: selectedOption?.points || 0,
            notes: question.notes || null,
            text_answer: null,
          };
        });
    } else if (question.field_type === "rearrange") {
      const questionId = currentSubCategory?.[subCategoryIndex]?.questions?.[0]?.question_id;

      const reorderedAnswersFromStore = allRearrangeAnswers?.[questionId] || question?.options || [];

      if (reorderedAnswersFromStore) {
        subCategory.isCompleted = true;
      }

      answersData = reorderedAnswersFromStore.map((opt, index) => ({
        sub_category_id: subCategory?.subCategory_id,
        sub_option_id: null,
        bearing_size: null,
        option_id: opt?.option_id,
        rank_id: index + 1,
        points: 0,
        notes: question.notes || null,
        text_answer: null,
      }));
    }
    else if (question.field_type === "matrix") {
      const isMatrixVal = matrixAnswers[question.question_id]?.find(item => item?.optionId)
      if (isMatrixVal) {
        subCategory.isCompleted = true;
      }
      answersData = question.subOptions
        .filter(subOpt => matrixAnswers[question.question_id]?.some(ans => ans.subOptionId === subOpt.sub_option_id))
        .map(subOpt => ({
          sub_category_id: subCategory?.subCategory_id || null,
          sub_option_id: subOpt.sub_option_id || null,
          bearing_size: null,
          option_id: matrixAnswers[question.question_id]?.find(
            ans => ans.subOptionId === subOpt.sub_option_id
          )?.optionId || null,
          rank_id: question.rank_id || null,
          points: subOpt.points || 0,
          notes: question.notes || null,
          text_answer: null,
        }));
    } else if (question.field_type === "text_box") {
      if (question?.textAnswer && question?.textAnswer?.length > 0) {
        subCategory.isCompleted = true;
      }
      answersData = (question?.textAnswer && question?.textAnswer?.length > 0) ? [{
        sub_category_id: subCategory.subCategory_id,
        sub_option_id: null,
        bearing_size: null,
        option_id: null,
        rank_id: question.rank_id || null,
        points: 0,
        notes: question.notes || null,
        text_answer: question.textAnswer || "",
      }]
        :
        [];
    } else if (question.field_type === "grease") {
      const greaseAns = getGreaseAnswers[question.question_id] || [];
      const hasValidGreaseAnswer = greaseAns.some(item => item?.greaseName || item?.greaseSize);
      subCategory.isCompleted = true;

      answersData = greaseAns.length > 0 ? greaseAns.map(ans => ({
        sub_category_id: subCategory?.subCategory_id || null,
        sub_option_id: null,
        bearing_size: null,
        option_id: ans.optionId || null,
        rank_id: question.rank_id || null,
        points: 0,
        notes: question.notes || null,
        text_answer: null,
        grease_name: ans.greaseName || null,
        grease_size: ans.greaseSize || null,
      })) : [{
        sub_category_id: subCategory?.subCategory_id || null,
        sub_option_id: null,
        bearing_size: null,
        option_id: null,
        rank_id: question.rank_id || null,
        points: 0,
        notes: question.notes || null,
        text_answer: null,
        grease_name: null,
        grease_size: null,
      }]
    } else if (question.field_type === "multi_check_box") {
      answersData = question.options
        .filter(opt => opt.isChecked)
        .map(opt => ({
          sub_category_id: subCategory.subCategory_id,
          sub_option_id: null,
          bearing_size: null,
          option_id: opt.option_id,
          rank_id: question.rank_id || null,
          points: opt?.points || 0,
          notes: question.notes || null,
          text_answer: null,
        }));
    } else {
      answersData = question.options.filter(opt => opt.isChecked).map(opt => ({
        sub_category_id: subCategory.subCategory_id,
        sub_option_id: null,
        bearing_size: null,
        option_id: opt.option_id,
        rank_id: question.rank_id || null,
        points: opt?.points || 0,
        notes: question.notes || null,
        text_answer: null,
      }));
    }

    const payload = {
      data: {
        data: {
          assessment_id: assessmentId,
          company_name: companyName,
          category_id: updatedData[catIndex].category_id,
          quesion_id: question.question_id,
          answersData,
          next_question_id: nextSubCategoryId || null,
        },
      },
    };

    return dispatch(saveIndividualAnswer(payload));
  };

  const areAllObjectValuesSame = (obj) => {
    const values = Object.values(obj)
    const firstValue = values[0];

    return values.every((val) => val === firstValue)
  }

  const isGreaseAnswerValid = (questionId) => {
    const greaseData = getGreaseAnswers?.[questionId];

    if (!greaseData || !Array.isArray(greaseData)) return false;

    // process answers in pairs [name, size]
    for (let i = 0; i < greaseData.length; i += 2) {
      const nameObj = greaseData[i];
      const sizeObj = greaseData[i + 1];

      if (
        !nameObj?.greaseName?.trim().length ||
        !sizeObj?.greaseSize?.trim().length
      ) {
        return false;
      }
    }

    return true;
  };



  const handleNext = async () => {
    let hasGreaseError = false;
    let jumpToQuestion = false;
    let nextSubCategoryId = null;


    setDirection(1);
    const updatedData = [...categories];
    const currentQuestionData = updatedData[categoryIndex].sub_categories[subCategoryIndex].questions;

    currentQuestionData.forEach(q => {

      q?.options?.forEach(opt => {
        if (!q?.is_bearing_size) {
          if (opt?.isChecked && opt?.next_question_id !== null) {
            jumpToQuestion = true;
            nextSubCategoryId = Number(opt?.next_question_id);
          }
        }

      });

      if (q.is_bearing_size && q.bearingSizeAnswers) {
        const bearingSizes = ['small', 'medium', 'large'];
        const optionsAnswered = {}
        const allSizesAnswered = bearingSizes.some(size => 
          q.bearingSizeAnswers[size] !== null &&
          q.bearingSizeAnswers[size] !== undefined
        );

        if (allSizesAnswered) {
          bearingSizes?.forEach((size, index) => {
            const selectedIndex = q.bearingSizeAnswers[size];
            const selectedOption = q.options?.[selectedIndex]?.next_question_id;
            optionsAnswered[index] = selectedOption;
          });
          const isObjVal = areAllObjectValuesSame(optionsAnswered)
          if (isObjVal) {
            const values = Object.values(optionsAnswered)[0]
            const noneOption = q?.options?.find(opt => opt?.next_question_id === values);
            if (noneOption?.next_question_id !== null) {
              jumpToQuestion = true;
              nextSubCategoryId = Number(noneOption?.next_question_id);
            }

          }
        }
      }
    });

    setHistory(prevHistory => [...prevHistory, updatedData[categoryIndex].sub_categories[subCategoryIndex].subCategory_id]);

    // Modified completion check to handle bearing size questions
    const completedQuestions = currentQuestionData.filter(question => {
      if (question.is_bearing_size) {
        // Check if all bearing sizes have an answer
        return question.bearingSizeAnswers &&
          ['small', 'medium', 'large'].some(size =>
            question.bearingSizeAnswers[size] !== null &&
            question.bearingSizeAnswers[size] !== undefined
          );
      } else {
        // Regular question completion check
        return question?.options?.some(option => option?.isChecked);
      }
    }).length;

    // Only mark as completed if all questions in the subcategory are answered

    // setSubCategoryIndex(subCategoryIndex + 1);
    let savePromises = [];

    if (Array.isArray(currentQuestionData) && currentQuestionData.length > 0) {
      savePromises = currentQuestionData.map((q) => {
        if (
          ["matrix", "rearrange", "check_box", "text_box", "grease", "multi_check_box"].includes(
            q?.field_type
          )
        ) {
          if (q.field_type === "grease") {
            if (!isGreaseAnswerValid(q.question_id)) {
              hasGreaseError = true;
            }
          }
          if (completedQuestions === currentQuestionData.length) {
            updatedData[categoryIndex].sub_categories[
              subCategoryIndex
            ].isCompleted = true;
            setValue("categories", updatedData);
          }
          const questionWithNotes = {
            ...q,
            notes: updatedData[categoryIndex].sub_categories[subCategoryIndex].questions[0]?.notes || "",
          };
          return sendIndividualAnswers(
            questionWithNotes,
            updatedData,
            categoryIndex,
            subCategoryIndex,
            nextSubCategoryId
          );
        }
        return Promise.resolve(); // return a resolved promise for non-applicable questions
      });
      if (hasGreaseError) {
        setSendErrorToChild(true)
        return;
      }
      await Promise.all(savePromises)
    } else {
      const insightsData = categories[categoryIndex].sub_categories[subCategoryIndex];
      const mediaFilesUrls = insightsData?.mediaFiles?.length
        ? insightsData?.mediaFiles.map((file) => file.url)
        : [];

      const insightsPayload = {
        assessment_id: assessmentId,
        company_name: companyName,
        category_id: selectedCategoryId,
        media_files: mediaFilesUrls,
        comments: insightsData?.comments,
      }
      const additionalInsights =
        (mediaFilesUrls && mediaFilesUrls?.length > 0) ||
        (insightsData?.comments && insightsData?.comments?.trim()?.length > 0);


      if (additionalInsights) {
        updatedData[categoryIndex].sub_categories[subCategoryIndex].isCompleted = true;
        setValue("categories", updatedData);
      }
      dispatch(saveIndividualInsight({
        data: insightsPayload,
      }))
    }

    await new Promise(res => setTimeout(res, 100));

    if (onAfterSkipSave) {
      await onAfterSkipSave();
    }

    if (jumpToQuestion && nextSubCategoryId) {
      const dummyIndex = updatedData[categoryIndex].sub_categories.findIndex(
        sub => sub.subCategory_id === nextSubCategoryId
      );

      if (dummyIndex !== -1) {
        setSubCategoryIndex(dummyIndex);
      } else {
        console.log("Subcategory not found for next_question_id:", nextSubCategoryId);
      }
    } else {
      setSubCategoryIndex(subCategoryIndex + 1);
    }

    scrollToTop();
  };



  const handlePrevious = () => {
    const updatedData = [...categories];

    if (isSubModuleClicked) {
      const completedBeforeCurrent = updatedData[categoryIndex].sub_categories
        .slice(0, subCategoryIndex)
        .reverse()
        .find(sub => sub.isCompleted);

      if (completedBeforeCurrent) {
        const prevIndex = updatedData[categoryIndex].sub_categories.findIndex(
          sub => sub.subCategory_id === completedBeforeCurrent.subCategory_id
        );
        if (prevIndex !== -1) {
          setDirection(-1);
          setSubCategoryIndex(prevIndex);
        }
      } else {
        setSubCategoryIndex(0);
      }

    } else {
      const previousSubCategoryId = history[history.length - 1];
      if (previousSubCategoryId !== undefined) {
        const prevIndex = updatedData[categoryIndex].sub_categories.findIndex(
          sub => sub.subCategory_id === previousSubCategoryId
        );
        if (prevIndex !== -1) {
          setDirection(-1);
          setSubCategoryIndex(prevIndex);
          setHistory(prev => prev.slice(0, -1));
        }
      }
    }

    scrollToTop();
  };




  const handleSave = () => {
    // const questionData = prepareQuestionData();
    // const currentQuestionData =
    //   categories[categoryIndex].sub_categories[subCategoryIndex].questions;

    // Check completion status before saving
    // const completedQuestions = currentQuestionData?.filter(question => {
    //   if (question.is_bearing_size) {
    //     return question.bearingSizeAnswers &&
    //       ['small', 'medium', 'large'].every(size =>
    //         question.bearingSizeAnswers[size] !== null &&
    //         question.bearingSizeAnswers[size] !== undefined
    //       );
    //   } else {
    //     return question.options.some(option => option.isChecked);
    //   }
    // }).length;

    // const insightsData = categories[categoryIndex].sub_categories[subCategoryIndex];
    // const mediaFilesUrls = insightsData?.mediaFiles?.length
    //   ? insightsData?.mediaFiles.map((file) => file.url)
    //   : [];

    // const payload = {
    //   company_name: companyName,
    //   category_id: selectedCategoryId,
    //   assessment_id: assessmentId,
    //   questions: questionData,
    //   insight: {
    //     media_files: mediaFilesUrls,
    //     comments: insightsData?.comments,
    //   },
    //   finalSubmit: false,
    // };

    // const insightsPayload = {
    //   assessment_id: assessmentId,
    //   company_name: companyName,
    //   category_id: selectedCategoryId,
    //   media_files: mediaFilesUrls,
    //   comments: insightsData?.comments,
    // }

    // const feedbackPayload = {
    //   assessmentId: assessmentId,
    //   categoryId: selectedCategoryId, // this should match the key in your state
    //   rating: feedbackRating  || 0, // use the category ID as key
    //   comment: feedbackComment || "", // same here
    // };


    // Update completion status before dispatching
    // const updatedData = [...categories];
    // if (completedQuestions === currentQuestionData.length) {
    //   updatedData[categoryIndex].sub_categories[
    //     subCategoryIndex
    //   ].isCompleted = true;
    //   setValue("categories", updatedData);
    // }

    // dispatch(saveIndividualInsight({
    //   data: insightsPayload,
    // }))

    // dispatch(
    //   getAssessmentAnswer_USER({
    //     data: payload,
    //     callBack: getAssessmentAnswerResponse,
    //   })
    // );

    const feedbackRating = ratingForModule[selectedCategoryId];
    const feedbackComment = feedbackForModule[selectedCategoryId];

    const hasFeedback =
      (typeof feedbackRating === "number" && feedbackRating > 0) ||
      (typeof feedbackComment === "string" && feedbackComment.trim().length > 0);

    const updatedData = [...categories];

    if (hasFeedback) {
      updatedData[categoryIndex].sub_categories[subCategoryIndex].isCompleted = true;
      setValue("categories", updatedData);
    }
    dispatch(
      userFeedbackModule({
        data: {
          assessmentId: assessmentId,
          categoryId: selectedCategoryId,
          rating: feedbackRating || 0,
          comment: feedbackComment || "",
        },
        callBack: moveNextModule,
      })
    );



    const isLastCategory = categoryIndex === categories.length - 1;
    const isLastSubCategory = subCategoryIndex === categories[categoryIndex]?.sub_categories?.length - 1;
    const isLastScreen = isLastCategory && isLastSubCategory;

    if (isLastScreen) {
      setShowSubmitBtn(true)
    }
  };

  const moveNextModule = () => {

    setShow(false);
    setSuccessOpen(true);
    setShowMoveToButton(true);
  }

  const handleSubmit = () => {
    // const questionData = [];
    // categories?.map((x) =>
    //   x?.sub_categories?.map((z) =>
    //     z?.questions?.map((item) => {
    //       const filteredOptions = item?.options?.filter((data) => data?.isChecked);
    //       filteredOptions?.map((ele) => {
    //         questionData.push({
    //           sub_category_id: z?.subCategory_id,
    //           question_id: item?.question_id,
    //           option_id: ele?.option_id,
    //           points: ele?.points,
    //           notes: item?.notes,
    //           bearing_size: item?.bearingOption?.value || "",
    //         });
    //       });
    //     })
    //   )
    // );

    // const insightsData = categories[categoryIndex].sub_categories[subCategoryIndex];
    // const mediaFilesUrls = Array.isArray(insightsData?.mediaFiles)
    //   ? insightsData.mediaFiles.map((file) => file.url)
    //   : [];

    // const payload = {
    //   company_name: companyName,
    //   category_id: selectedCategoryId,
    //   assessment_id: assessmentId,
    //   questions: questionData,
    //   insight: {
    //     media_files: mediaFilesUrls,
    //     comments: insightsData?.comments,
    //   },
    //   finalSubmit: true,
    // };
    // Dispatch feedback
    setIsLoader(true)
    dispatch(
      addUserFeedback({
        data: {
          backlog_id: Number(backlog_id),
          feedback: feedback.trim(),
          rating: Number(rating)
        }
      })
    );

    dispatch(
      userFinalSubmit({
        data: {
          assessment_id: assessmentId,
          callBack: closeSubmitModal,
        },
      })
    );

    // dispatch(
    //   getAssessmentAnswer_USER({
    //     data: payload,
    //     callBack: getAssessmentSubmitAnswerResponse,
    //   })
    // );

  };

  const closeSubmitModal = () => {
    setShow(false);
    setTimeout(() => {
      navigate("/pre-assessment");
      setIsLoader(false);
    }, 1500);
  };


  const getAssessmentAnswerResponse = () => {
    setShow(false);
    setSuccessOpen(true);
    setShowMoveToButton(true);
    const updatedData = [...categories];
    const hasMediaFiles =
      categories[categoryIndex]?.sub_categories?.[subCategoryIndex]?.mediaFiles
        .length > 0;
    const hasComments =
      categories[categoryIndex]?.sub_categories[
        subCategoryIndex
      ]?.comments.trim() !== "";

    if (hasMediaFiles || hasComments) {
      updatedData[categoryIndex].sub_categories[
        subCategoryIndex
      ].isCompleted = true;
      setValue("categories", updatedData);
    }
  };

  const getAssessmentSubmitAnswerResponse = () => {
    setShow(false);
    setSuccessOpen(true);
    setShowMoveToButton(false);
    const updatedData = [...categories];
    const hasMediaFiles =
      categories[categoryIndex]?.sub_categories?.[subCategoryIndex]?.mediaFiles
        .length > 0;
    const hasComments =
      categories[categoryIndex]?.sub_categories[
        subCategoryIndex
      ]?.comments.trim() !== "";

    if (hasMediaFiles || hasComments) {
      updatedData[categoryIndex].sub_categories[
        subCategoryIndex
      ].isCompleted = true;
      setValue("categories", updatedData);
    }
    setTimeout(() => { navigate("/pre-assessment"); }, 5000);
  };

  const handleBackToHome = () => {
    navigate("/pre-assessment");
  };

  const handleNextModule = () => {
    setSuccessOpen(false);
    setSelectedCategoryId(selectedCategoryId + 1);
    setCategoryIndex(categoryIndex + 1);
    setSubCategoryIndex(0);
    scrollToTop('.container-sidebar')
  };
  const hasMatrixQuestion = currentSubCategory?.[subCategoryIndex]?.questions?.some(
    (q) => q.field_type === 'matrix'
  );

  const isRearrangable = currentSubCategory?.[subCategoryIndex]?.questions?.some(
    (q) => q.field_type === 'rearrange'
  );

  const isTextBox = currentSubCategory?.[subCategoryIndex]?.questions?.some(
    (q) => q.field_type === 'text_box'
  );

  const isGreaseType = currentSubCategory?.[subCategoryIndex]?.questions?.some(
    (q) => q.field_type === 'grease'
  );

  const isMultiCheck = currentSubCategory?.[subCategoryIndex]?.questions?.some(
    (q) => q.field_type === 'multi_check_box'
  );
  const isLastCategory = categoryIndex === categories.length - 1;
  const isLastSubCategory = subCategoryIndex === categories[categoryIndex]?.sub_categories?.length - 1;
  const isLastScreen = isLastCategory && isLastSubCategory;


  const getRearrangeSavedAnswers = (questionId) => {
    return savedAnswersFromAPI?.filter(ans => ans.question_id === questionId) || [];
  };

  const watchedCategories = watch("categories");

  const currentNotes =
    watchedCategories?.[selectedCategoryId]?.sub_categories?.[subCategoryIndex]?.questions?.[0]?.notes || "";

  return (
    <>
      {successOpen ? (
        <div className="d-flex  flex-column align-items-center justify-content-center mt-5">
          <SuccessCard successType={showMoveToButton ? "Save" : false} isLast={isLastScreen} />
          <div className="d-flex align-items-center justify-content-center my-3" style={{ flexWrap: "wrap" }}>
            <Button
              title="Back to home"
              buttonStyle={outlineButton}
              titleStyle={outlineTitle}
              onClick={handleBackToHome}
            />
            {showMoveToButton && !showSubmitBtn ? (
              <>
                <Button
                  title={`Move to ${capitalizeFirstLetter(
                    nextCategoryName?.category_name
                  )}`}
                  buttonStyle={moveToButton}
                  titleStyle={moveToButtonTitle}
                  onClick={handleNextModule}
                />
                <div style={{ width: "90%", marginTop: "12px" }}>
                  <Button
                    title="Submit"
                    buttonStyle={{
                      padding: "10px 21px",
                      cursor: "pointer",
                      backgroundColor: "#1f2155",
                      border: "solid 1px grey",
                      height: "44px"
                    }}
                    titleStyle={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      color: "white"
                    }}
                    onClick={() => setShow(true)}
                  />
                </div>
              </>
            ) : (
              <Button
                title={"Submit"}
                buttonStyle={{
                  padding: "7px 21px",
                  cursor: "pointer",
                  backgroundColor: "#1f2155",
                  border: "solid 1px grey",
                  width: "186px",
                  marginTop: "10px",
                  height: "44px"
                }}
                titleStyle={{
                  fontSize: "16px",
                  fontWeight: "normal",
                  color: "white",
                }}
                onClick={() => setShow(true)}
              />
            )}
          </div>
        </div>
      ) : (
        <div style={{ position: "relative", minHeight: '600px' }}>
          <AnimatePresence custom={direction} mode="wait">
            <motion.div
              key={subCategoryIndex}
              custom={direction}
              variants={slideVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ type: "tween", duration: 0.4 }}
              style={{ position: "absolute", top: 0, left: 0, width: "100%" }}
              ref={questionsRef}
              className="questions-container"
            >
              {currentSubCategory?.[subCategoryIndex] && currentSubCategory?.[subCategoryIndex]?.questions?.length === 0 && !currentSubCategory?.[subCategoryIndex]?.isFeedback ? (
                <>
                  <div className="additional-insights-container">
                    <h3>Additional insights</h3>
                    <div className="upload-media">
                      <label>Upload media</label>
                      <div className="filess">
                        {isLoading === "loading" ? (
                          <Loader />
                        ) : (
                          <FileUploader
                            multiple
                            name="mediaFiles"
                            classes="drop_area drop_zone"
                            handleChange={(e) =>
                              handleFileChange(e, categoryIndex, subCategoryIndex)
                            }
                          >
                            <p className="drag">
                              <span className="mx-2 my-1">
                                <img src={DragandDrop} alt="upload" />
                              </span>
                              Drag your file here or upload to{" "}
                              <span className="here mx-2">browse</span>
                            </p>
                          </FileUploader>)}
                        <div className="my-2 uploadNote">
                          Note: Only images (JPG, JPEG, PNG), PDFs, word documents (DOCX), and excel files (XLSX) are allowed. File size must not exceed 5MB, and images should be in clear resolution.
                        </div>
                      </div>
                      {errors?.mediaFiles && (
                        <div className="error-message" style={{ color: "red" }}>
                          {errors?.mediaFiles?.message}
                        </div>
                      )}
                      <div className="uploaded-files">
                        {Array.isArray(
                          categories[categoryIndex]?.sub_categories?.[
                            subCategoryIndex
                          ]?.mediaFiles
                        ) &&
                          categories[categoryIndex]?.sub_categories?.[
                            subCategoryIndex
                          ]?.mediaFiles.map((file, index) => (
                            <div key={index} className="file-item">
                              <span className="me-2">{file.name}</span>{" "}
                              {/* Display the original name */}
                              <MdDeleteOutline
                                onClick={
                                  () =>
                                    handleRemoveFile(
                                      file.url,
                                      categoryIndex,
                                      subCategoryIndex
                                    ) // Use the URL for removal
                                }
                                color="#1f2155"
                                size={25}
                                className="remove-icon"
                              />
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="comments-section">
                      <label>Comments</label>
                      <textarea
                        placeholder="Enter your comments here..."
                        className="notes-input"
                        value={
                          categories[categoryIndex]?.sub_categories[
                            subCategoryIndex
                          ]?.comments
                        }
                        onChange={(e) =>
                          handleComments(categoryIndex, subCategoryIndex, e)
                        }
                      />
                    </div>
                  </div>
                </>
              ) :
                currentSubCategory?.[subCategoryIndex]?.isFeedback ? (
                  <>
                    <div className="question-item mb-4 feedback-container" style={{ padding: 20 }}>
                      <h3>Feedback</h3>
                      <ReactQuill
                        theme="snow"
                        value={feedbackForModule[categories[categoryIndex]?.category_id] || ""}
                        onChange={(val) =>
                          setFeedbackForModule(prev => ({
                            ...prev,
                            [categories[categoryIndex]?.category_id]: val,
                          }))
                        }
                        placeholder="Enter your feedback here..."
                        className="styled-quill-editor"
                        modules={{
                          toolbar: [
                            [{ header: [1, 2, 3, false] }],
                            ["bold", "italic", "underline"],
                            [{ list: "ordered" }, { list: "bullet" }],
                            ["clean"],
                          ],
                        }}
                        formats={[
                          "header",
                          "bold",
                          "italic",
                          "underline",
                          "list",
                          "bullet",
                        ]}
                      />
                      <div
                        className="d-flex flex-row mb-3"
                        style={{ alignItems: "baseline", gap: "20px", justifyContent: "center" }}
                      >
                        <p className="text-conformation">Rating:</p>
                        <div className="star-rating">
                          {[1, 2, 3, 4, 5].map(star => (
                            <span
                              key={star}
                              className={`star ${hoveredRatingForModule !== null
                                ? star <= hoveredRatingForModule ? "hovered" : ""
                                : star <= (ratingForModule[categories[categoryIndex]?.category_id] || 0) ? "filled" : ""
                                }`}
                              onClick={() =>
                                setRatingForModule(prev => ({
                                  ...prev,
                                  [categories[categoryIndex]?.category_id]: star,
                                }))
                              }
                              onMouseEnter={() => setHoveredRatingForModule(star)}
                              onMouseLeave={() => setHoveredRatingForModule(null)}
                            >
                              ★
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>

                  </>
                )
                  :
                  hasMatrixQuestion ? <MatrixQuestions
                    question={currentSubCategory?.[subCategoryIndex]}
                    savedAnswers={savedAnswersFromAPI}
                    onNotesChange={handleNotes}
                    notes={
                      currentSubCategory?.[subCategoryIndex]?.questions?.[0]?.notes || ""
                    }
                    categoryIndex={categoryIndex}
                    subCategoryIndex={subCategoryIndex}
                    questionIndex={0}
                    matrixAnswers={matrixAnswers}
                    setMatrixAnswers={setMatrixAnswers}
                  /> :
                    isRearrangable ? <RearrangementQuestion
                      questionData={currentSubCategory?.[subCategoryIndex]?.questions?.[0]}
                      savedAnswers={
                        allRearrangeAnswers?.[
                        currentSubCategory?.[subCategoryIndex]?.questions?.[0]?.question_id
                        ] || currentSubCategory?.[subCategoryIndex]?.questions?.[0]?.options
                      }
                      onNotesChange={handleNotes}
                      notes={
                        currentSubCategory?.[subCategoryIndex]?.questions?.[0]?.notes || ""
                      }
                      categoryIndex={categoryIndex}
                      subCategoryIndex={subCategoryIndex}
                      questionIndex={0} /> :
                      isTextBox ? (
                        currentSubCategory?.[subCategoryIndex]?.questions?.map(
                          (ele, questionIndex) => {
                            return (
                              <div className="question-item mb-4" style={{ padding: 20 }}>
                                <h4>{ele?.question_id}. {ele?.question}</h4>
                                <div className="option-items" key={questionIndex}>
                                  <textarea
                                    style={{ resize: "none", padding: "8px" }}
                                    placeholder="Enter answer here..."
                                    className="answer-input"
                                    value={ele?.textAnswer}
                                    onChange={(e) =>
                                      handleTextAnswer(
                                        categoryIndex,
                                        subCategoryIndex,
                                        questionIndex,
                                        "textAnswer",
                                        e
                                      )
                                    }
                                  />
                                </div>
                                <div className="option-items">
                                  <h4>Add your notes</h4>
                                  <textarea
                                    placeholder="Enter here..."
                                    className="notes-input"
                                    value={ele?.notes}
                                    onChange={(e) =>
                                      handleNotes(
                                        categoryIndex,
                                        subCategoryIndex,
                                        questionIndex,
                                        "notes",
                                        e
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            );
                          }
                        )
                      ) : isGreaseType ? <GreaseType
                        questions={currentSubCategory?.[subCategoryIndex]}
                        savedAnswers={savedGreaseAnswers}
                        onNotesChange={handleNotes}
                        notes={
                          currentSubCategory?.[subCategoryIndex]?.questions?.[0]?.notes || ""
                        }
                        categoryIndex={categoryIndex}
                        subCategoryIndex={subCategoryIndex}
                        questionIndex={0}
                        sendErrorToChild={sendErrorToChild}
                        setSendErrorToChild={setSendErrorToChild}
                      /> :
                        isMultiCheck ?
                          currentSubCategory?.[subCategoryIndex]?.questions?.map((ele, questionIndex) => {
                            return (
                              <div key={questionIndex} className="question-item mb-4">
                                <h4>
                                  {ele?.question_id}.&nbsp;{ele?.question}
                                </h4>
                                <div className="option-items">
                                  {ele?.options?.map((option, optionIndex) => (
                                    <div key={optionIndex} className="option-item">
                                      <Checkbox
                                        label={option.title}
                                        checked={option.isChecked}
                                        style={{ borderRadius: "2px", border: "1px solid black" }}
                                        onChange={() =>
                                          handleMultiCheckChange(
                                            categoryIndex,
                                            subCategoryIndex,
                                            questionIndex,
                                            optionIndex,
                                            // "isChecked"
                                          )
                                        }
                                      />
                                    </div>
                                  ))}
                                </div>
                                <div className="option-items">
                                  <h4>Add your notes</h4>
                                  <textarea
                                    placeholder="Enter here..."
                                    className="notes-input"
                                    value={ele?.notes}
                                    onChange={(e) =>
                                      handleNotes(
                                        categoryIndex,
                                        subCategoryIndex,
                                        questionIndex,
                                        "notes",
                                        e
                                      )
                                    }
                                  />
                                </div>
                              </div>

                            )
                          }) :
                          (
                            <>
                              {currentSubCategory?.[subCategoryIndex]?.questions?.map(
                                (ele, questionIndex) => {
                                  return (
                                    <div key={questionIndex} className="question-item mb-4">
                                      <h4>
                                        {ele?.question_id}.&nbsp;{ele?.question}
                                      </h4>
                                      {!ele?.is_bearing_size && (
                                        <div className="option-items">
                                          {ele?.options?.map((option, optionIndex) => (
                                            <div key={optionIndex} className="option-item">
                                              <RadioButton
                                                label={option.title}
                                                isSelected={option.isChecked}
                                                name="isChecked"
                                                onChange={() =>
                                                  handleChange(
                                                    categoryIndex,
                                                    subCategoryIndex,
                                                    questionIndex,
                                                    optionIndex,
                                                    "isChecked"
                                                  )
                                                }
                                              />
                                            </div>
                                          ))}
                                        </div>)}
                                      {ele?.is_bearing_size && (
                                        <>
                                          {['small', 'medium', 'large'].map((size) => (
                                            <div key={size} className="bearing-size-section">
                                              <h5 className="mt-3 mb-2">
                                                Select for {size} bearing size  &nbsp;
                                                ({size === 'small' ? '<55mm' : size === 'medium' ? '55mm - 200mm' : '>200mm'})
                                              </h5>
                                              <div className="option-items">
                                                {ele?.options?.map((option, optionIndex) => (
                                                  <div key={optionIndex} className="option-item">
                                                    <RadioButton
                                                      label={option.title}
                                                      isSelected={getSelectedOption(ele, size, optionIndex)}
                                                      name={`${size}_isChecked`}
                                                      onChange={() =>
                                                        handleChange(
                                                          categoryIndex,
                                                          subCategoryIndex,
                                                          questionIndex,
                                                          optionIndex,
                                                          "isChecked",
                                                          size
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          ))}
                                        </>
                                      )}
                                      <div className="option-items">
                                        <h4>Add your notes</h4>
                                        <textarea
                                          placeholder="Enter here..."
                                          className="notes-input"
                                          value={ele?.notes}
                                          onChange={(e) =>
                                            handleNotes(
                                              categoryIndex,
                                              subCategoryIndex,
                                              questionIndex,
                                              "notes",
                                              e
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </>
                          )}

              {currentSubCategory?.[subCategoryIndex]?.isFeedback ? (
                <div className="row justify-content-end my-3">
                  <div className="col-2">
                    <Button
                      title="Previous"
                      onClick={handlePrevious}
                      buttonStyle={{
                        padding: "7px 21px",
                        cursor: "pointer",
                        backgroundColor: "white",
                        border: "solid 1px grey",
                        boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                      }}
                      titleStyle={{
                        fontSize: "16px",
                        fontWeight: "normal",
                        color: "black",
                      }}
                    />
                  </div>
                  {
                    categories[categoryIndex]?.isAnswered && !isLastScreen && !showSubmitBtn ? (
                      <>
                        {/* <Button
                        title={`Move to ${capitalizeFirstLetter(
                          nextCategoryName?.category_name
                        )}`}
                        buttonStyle={savedMoveToButton}
                        titleStyle={moveToButtonTitle}
                        onClick={handleNextModule}
                      /> */}
                        <div className="col-2">
                          <Button
                            title="Save"
                            buttonStyle={{
                              padding: "7px 21px",
                              cursor: "pointer",
                              backgroundColor: "#1f2155",
                              border: "solid 1px grey",
                            }}
                            titleStyle={{
                              fontSize: "16px",
                              fontWeight: "normal",
                              color: "white",
                            }}
                            onClick={handleSave}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {(categoryIndex < categories.length - 1 || isLastScreen) && (
                          <div className="col-2">
                            <Button
                              title="Save"
                              buttonStyle={{
                                padding: "7px 21px",
                                cursor: "pointer",
                                backgroundColor: "#1f2155",
                                border: "solid 1px grey",
                              }}
                              titleStyle={{
                                fontSize: "16px",
                                fontWeight: "normal",
                                color: "white",
                              }}
                              onClick={handleSave}
                            />
                          </div>
                        )}
                        {/* {categoryIndex === categories.length - 1 && showSubmitBtn && (
                        <div className="col-2">
                          <Button
                            title={"Submit"}
                            buttonStyle={{
                              padding: "7px 21px",
                              cursor: "pointer",
                              backgroundColor: "#1f2155",
                              border: "solid 1px grey",
                            }}
                            titleStyle={{
                              fontSize: "16px",
                              fontWeight: "normal",
                              color: "white",
                            }}
                            onClick={() => setShow(true)}
                          />
                        </div>
                      )} */}
                      </>
                    )}
                </div>
              ) : (
                <div className="row justify-content-end my-3">
                  {subCategoryIndex !== 0 && (
                    <div className="col-2">
                      <Button
                        title="Previous"
                        onClick={handlePrevious}
                        buttonStyle={{
                          padding: "7px 21px",
                          cursor: "pointer",
                          backgroundColor: "white",
                          border: "solid 1px grey",
                          boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                        }}
                        titleStyle={{
                          fontSize: "16px",
                          fontWeight: "normal",
                          color: "black",
                        }}
                      />
                    </div>
                  )}

                  <div className="col-2">
                    <Button
                      title="Next"
                      onClick={handleNext}
                      buttonStyle={{
                        padding: "7px 21px",
                        cursor: "pointer",
                      }}
                      titleStyle={{
                        fontSize: "16px",
                        fontWeight: "100",
                      }}
                    />
                  </div>
                </div>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      )}



      <Modal show={show} onHide={() => setShow(false)} centered size="md">
        <Modal.Body>
          <div className="text-center">
            <div className="info">
              <h2 className="logout-heading">Confirmation</h2>
              <p className="text-conformation">
                Are you sure you want to submit this assessment ?
              </p>
            </div>

            {/* Feedback textarea */}
            <div className="d-flex flex-column mb-3">
              <p className="text-conformation">Your Feedback:</p>
              <textarea
                className="form-control fs-8"
                rows={3}
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
            </div>

            {/* Rating input */}
            <div className="d-flex flex-row mb-3" style={{ alignItems: "baseline", gap: "20px", justifyContent: "center" }}>
              <p className="text-conformation">Rating:</p>
              <div className="star-rating">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={`star ${hoveredRating !== null
                      ? star <= hoveredRating
                        ? "hovered"
                        : ""
                      : star <= rating
                        ? "filled"
                        : ""
                      }`}
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHoveredRating(star)}
                    onMouseLeave={() => setHoveredRating(null)}
                  >
                    ★
                  </span>
                ))}
              </div>

            </div>

            <div className="button-container">
              <button className="cancel-button" onClick={() => setShow(false)}>
                Cancel
              </button>
              <button className="logout-button" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {isLoader && (
        <div
          className="loader-wrapper"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <Loader />
        </div>
      )}

    </>
  );
};

export default QuestionaryComponent;
